<template>
  <modal
    ref="oracleProjectTaskModal"
    :title="$t('orders.fillOracleEmitterProjectAndTask')"
    :action="$t('common.validate')"
    @create="submit"
    @close="close"
  >
    <div class="columns">
      <div class="column is-half">
        <many2one-field
          :label="$t('entities.oracleEmitterProject')"
          v-model="formData.oracleEmitterProject"
          :fetch="$api.fetchOracleProjectsByProject.bind(this, projectId)"
          reference="name"
          entity="oracle_project"
          :columns="oracleProjectColumns"
          :edit="true"
          :hasFilter="true"
          :inline="false"
          required
          v-validate="{ required: true }"
          name="oracleEmitterProject2one"
          :error="errors.has('oracleEmitterProject2one')"
        ></many2one-field>

        <many2one-field
          :label="$t('entities.oracleEmitterTask')"
          v-model="formData.oracleEmitterTask"
          :fetch="
            $api.fetchOracleTasksByOracleProject.bind(
              this,
              formData.oracleEmitterProject && formData.oracleEmitterProject.projectId
            )
          "
          reference="name"
          entity="oracle_task"
          :columns="oracleTaskColumns"
          :edit="true"
          :hasFilter="false"
          :inline="false"
          :readonly="formData.oracleEmitterProject == null"
          required
          v-validate="{ required: true }"
          name="oracleEmitterTask2one"
          :error="errors.has('oracleEmitterTask2one')"
        >
          <span
            slot="helper"
            v-if="formData.oracleEmitterProject == null"
          >
            {{ $t("orders.needOracleProject") }}
          </span>
        </many2one-field>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'OracleProjectTaskModal',
  inject: ['$validator'],
  props: {
    projectId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      formData: {
        oracleEmitterProject: null,
        oracleEmitterTask: null
      },
      oracleProjectColumns: {
        name: this.$t('common.name'),
        description: this.$t('common.description')
      },
      oracleTaskColumns: {
        name: this.$t('common.name'),
        description: this.$t('common.description')
      }
    }
  },
  methods: {
    open() {
      this.$refs.oracleProjectTaskModal.open()
    },
    close() {
      this.$refs.oracleProjectTaskModal.close()
      this.$emit('cancel')
    },
    async submit() {
      const isValid = await this.$validator.validateAll()
      if (isValid) {
        this.$emit('submit', { ...this.formData })
        this.close()
      }
    }
  }
}
</script>
